import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { SubFamilyId } from "@/features/sub-families/types";
import type { ImageType, Nullable } from "@/types";

type State = {
    id: SubFamilyId;
    family: string;
    name: string;
    image: Nullable<ImageType>;
    technicalDrawing: Nullable<ImageType>;
};

const initialState: State = {
    id: "" as SubFamilyId,
    family: "",
    name: "",
    image: null,
    technicalDrawing: null,
};

const slice = createSlice({
    name: "sub-family",
    initialState,
    reducers: {
        subFamilySetAction: (state: State, action: PayloadAction<SubFamilySetActionPayload>) => {
            state.id = action.payload.id;
            state.name = action.payload.name;
        },
        subFamilySetFamilyAction: (state: State, action: PayloadAction<string>) => {
            state.family = action.payload;
        },
        subFamilySetTechnicalDrawingAction: (state: State, action: PayloadAction<Nullable<ImageType>>) => {
            state.technicalDrawing = action.payload;
        },
        subFamilySetImageAction: (state: State, action: PayloadAction<Nullable<ImageType>>) => {
            state.image = action.payload;
        },
    },
});

export const {
    subFamilySetAction,
    subFamilySetFamilyAction,
    subFamilySetTechnicalDrawingAction,
    subFamilySetImageAction,
} = slice.actions;

export default slice.reducer;

type SubFamilySetActionPayload = { id: SubFamilyId; name: string };
